import { useCallback, useEffect, useState } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import { viewCollectionsList } from "../../Redux/Actions/collectionsActions";
import { columnsCollectionsResale } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";

const ListCollections = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(async (page, limit) => {
    const collectionData = {
      page,
      limit: limit,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };
    try {
      await dispatch(viewCollectionsList(collectionData));
    } catch {
      toast.error("Failed to fetch projects");
    }
  },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);


  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, debouncedSearch, dateRange, fetchDetails]);


  const { collections, loading } = useSelector((state) => state.collections);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  useEffect(() => {
    if (collections?.total) {
      setPagination((prevData) => ({ ...prevData, total: collections.total }));
    }
  }, [collections]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    setDateRange(start === null && end === null ? { start: null, end: null } : { start, end });
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);


  return (
    <>
      <TableComponent
        h3heading="Collections Resale List"
        buttonhead2={canAdd ? "Add Collections" : null}
        navigateTo2={canAdd ? "/collections/add" : null}
        columns={columnsCollectionsResale(canEdit)}
        setState={setSearchQuery}
        dataSource={Array.isArray(collections?.data) ? collections.data : []}
        pagination={pagination}
        loading={loading}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        onChange={handleTableChange}
      ></TableComponent>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListCollections;
